/* customers-referearn-v2.js */

function postJson(url, data) {
  return fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data || {}),
    credentials: "same-origin",
  }).then(async (res) => {
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error("HTTP_ERROR");
      err.payload = json;
      throw err;
    }
    return { data: json };
  });
}

function toNumber(v) {
  const n = Number(String(v).replace(/[^\d.-]/g, ""));
  return Number.isFinite(n) ? n : 0;
}

// Format integer (for points display)
function formatInt(v) {
  const n = Math.round(toNumber(v));
  const locale = document.documentElement.lang || undefined;
  return new Intl.NumberFormat(locale).format(n);
}

function clampText(str) {
  return String(str || "")
    .replace(/\s+/g, " ")
    .trim();
}

function hasDisplayValue(value) {
  return value != null && String(value).trim() !== "";
}

// 与 snippets/shop-timezone.liquid 的 display 输出对齐：UTC±HH:MM（如 UTC+08:00 / UTC-10:00）
function getShopTzDisplay() {
  const iso =
    (typeof window !== "undefined" &&
      (window.RRFormatTimestamp?.getShopUtcOffsetIso?.() ||
        window.SHOP_UTC_OFFSET_ISO)) ||
    "";
  const trimmed = String(iso).trim();
  if (!/^[+-]\d{2}:\d{2}$/.test(trimmed)) return "";
  return `UTC${trimmed}`;
}

function formatOrderTimeDisplay(item, formatTs) {
  if (hasDisplayValue(item?.orderTimestamp)) {
    const formatted = formatTs(item.orderTimestamp);
    if (hasDisplayValue(formatted) && formatted !== "-") {
      const tz = getShopTzDisplay();
      return tz ? `${formatted} ${tz}` : formatted;
    }
  }

  const fallback = clampText(item?.orderTime);
  return fallback || "-";
}

function getRewardStatus(item) {
  // Backend seems to use: claimed / earned_not_claimed / others
  const status = item?.status || item?.levelReward?.status || "";
  if (status === "earned_not_claimed") return "claimable";
  if (status === "claimed") return "claimed";
  return "locked";
}

/**
 * Task progress milestone card state (Figma ReferAndEarnAtomic):
 * locked | claimable | claimed | reached_pending ("已到达，暂不可领").
 */
function getStepDisplayState(item, progressAmount) {
  const lr = item?.levelReward ?? item;
  const status = String(lr?.status || item?.status || "");
  const threshold = toNumber(item.amount);

  if (status === "claimed") return "claimed";
  if (status === "earned_not_claimed") return "claimable";
  if (progressAmount >= threshold) return "reached_pending";
  return "locked";
}

function getI18n(root) {
  return {
    ...((window.CustomersReferEarnV2 && window.CustomersReferEarnV2.i18n) ||
      {}),
    error_generic:
      root?.dataset?.textError || "Failed to get. Please try again later.",
    receive: root?.dataset?.textReceive || "Receive",
    received: root?.dataset?.textReceived || "Received",
    cannot_receive: root?.dataset?.textCannot_receive || "Cannot receive",
    promo_codes: root?.dataset?.textPromo_codes || "Referral Codes",
    points: root?.dataset?.textPoints || "Points",
    points_unit: root?.dataset?.textPoints_unit || "points",
    help: root?.dataset?.textHelp || "Help",
    mobile_price_label: root?.dataset?.textMobilePriceLabel || "Price:",
    mobile_order_time_label:
      root?.dataset?.textMobileOrderTimeLabel || "Order Time:",
  };
}

function setHidden(el, hidden) {
  if (!el) return;
  if (hidden) {
    el.setAttribute("hidden", "");
    el.style.display = "none";
  } else {
    el.removeAttribute("hidden");
    el.style.display = "";
  }
}

function ensureModuleLoaded() {
  // Ensure RoDialog / RoPaginate are registered (section imports them as modules)
  // No-op here, but kept for clarity.
}

document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector("[data-customers-referearn-v2]");
  if (!root) return;

  ensureModuleLoaded();

  const i18n = getI18n(root);
  const inviteUrl = root.dataset.inviteUrl || "/pages/refer-and-earn";
  const currency = root.dataset.currency || "USD";
  const formatTs =
    typeof window.formatTimestampBySiteTimezone === "function"
      ? window.formatTimestampBySiteTimezone
      : (raw) => {
          if (!hasDisplayValue(raw)) return "-";
          return String(raw).trim();
        };

  // Get <ro-money> HTML string for innerHTML (uses currency from closure)
  function moneyHtml(value) {
    return `<ro-money value="${toNumber(
      value,
    )}" currency="${currency}"></ro-money>`;
  }

  const els = {
    currentAmount: root.querySelector(".crv2-progress-current"),
    totalAmount: root.querySelector(".crv2-progress-total"),
    track: root.querySelector("[data-crv2-track]"),
    scrollbox: root.querySelector("[data-crv2-scrollbox]"),
    tbody: root.querySelector("[data-crv2-tbody]"),
    cards: root.querySelector("[data-crv2-cards]"),
    historyList: root.querySelector("[data-crv2-history-list]"),
    historyEmpty: root.querySelector("[data-crv2-history-empty]"),
    tablewrap: root.querySelector("[data-crv2-tablewrap]"),
    cardswrap: root.querySelector("[data-crv2-cardswrap]"),
    inviteBtn: root.querySelector("[data-crv2-history-invite]"),
    paginateWrap: root.querySelector("[data-crv2-paginate]"),
    paginate: root.querySelector("ro-paginate"),
    lastEventWrap: root.querySelector("[data-crv2-last-event]"),
    lastEventBtn: root.querySelector("[data-crv2-last-event-btn]"),
    currentEventBtn: root.querySelector("[data-crv2-current-event-btn]"),
    dialog: root.querySelector("#crv2-success-dialog"),
    dialogTitle: root.querySelector("[data-crv2-dialog-title]"),
    dialogDesc: root.querySelector("[data-crv2-dialog-desc]"),
    dialogClose: root.querySelector("[data-crv2-dialog-close]"),
  };

  const state = {
    activityCode: "",
    beforeActivityCode: "",
    progressBar: null,
    rewardList: null,
    page: 1,
    totalPages: 1,
    clientPaginate: false,
    clientPageSize: 10,
    busy: false,
  };

  function showError() {
    if (typeof RoToast !== "undefined" && RoToast.error) {
      RoToast.error(i18n.error_generic);
    } else {
      // Fallback to alert if RoToast is not available
      // eslint-disable-next-line no-alert
      alert(i18n.error_generic);
    }
  }

  function openSuccessDialog({ title, desc }) {
    if (els.dialogTitle) els.dialogTitle.textContent = title || "";
    if (els.dialogDesc) els.dialogDesc.textContent = desc || "";
    if (els.dialog && typeof els.dialog.open === "function") {
      els.dialog.open();
    }
  }

  function closeSuccessDialog() {
    if (els.dialog && typeof els.dialog.close === "function") {
      els.dialog.close();
    }
  }

  function renderProgress() {
    const pb = state.progressBar;
    if (!pb || !Array.isArray(pb.levelList)) return;

    const levelList = pb.levelList || [];
    const last = levelList[levelList.length - 1] || {};

    const current = pb.notEarnedAmount ?? 0;
    const total = last.amount ?? 0;
    // Update <ro-money> elements in template (value attribute triggers re-render)
    if (els.currentAmount) {
      els.currentAmount.setAttribute("value", current);
    }
    if (els.totalAmount) {
      els.totalAmount.setAttribute("value", total);
    }

    // last event toggles — align with legacy: show "Last event" only when API returns
    // beforeActivityCode; when user is viewing past activity, show "Return to current" instead.
    state.beforeActivityCode = pb.beforeActivityCode || "";
    if (!state.beforeActivityCode) {
      state.activityCode = "";
    }
    const viewingPast =
      Boolean(state.beforeActivityCode) &&
      state.activityCode === state.beforeActivityCode;
    if (els.lastEventWrap)
      setHidden(els.lastEventWrap, !state.beforeActivityCode);
    if (els.lastEventBtn)
      setHidden(els.lastEventBtn, !state.beforeActivityCode || viewingPast);
    if (els.currentEventBtn) setHidden(els.currentEventBtn, !viewingPast);

    // build steps
    if (!els.track) return;
    els.track.innerHTML = "";

    const progressAmount = toNumber(pb.notEarnedAmount ?? 0);

    levelList.forEach((item, idx) => {
      const stepState = getStepDisplayState(item, progressAmount);
      const rewardType = Number(item.rewardType || 0);

      const stepEl = document.createElement("div");
      stepEl.className = "crv2-step";
      if (stepState === "claimed") stepEl.classList.add("crv2-step--claimed");
      if (stepState === "claimable")
        stepEl.classList.add("crv2-step--claimable");
      if (stepState === "reached_pending")
        stepEl.classList.add("crv2-step--reached-pending");
      stepEl.dataset.index = String(idx);

      const card = document.createElement("div");
      card.className = "crv2-step-card";

      const top = document.createElement("div");
      top.className = "crv2-step-top";

      const value = document.createElement("div");
      value.className = "crv2-step-value";

      const sub = document.createElement("div");
      sub.className = "crv2-step-sub";

      const subText = document.createElement("span");

      if (rewardType === 1) {
        value.textContent = formatInt(item.rewardPoints);
        subText.textContent = i18n.points;
      } else {
        // coupon/promo: prefer discountTitle as display value
        const title =
          item?.ruleInfo?.discountTitle ||
          item?.discountTitle ||
          item?.rewardTitle;
        if (title) {
          value.textContent = clampText(title);
        } else {
          value.innerHTML = moneyHtml(item.rewardAmount || 0);
        }
        subText.textContent = i18n.promo_codes;
      }

      const tooltipWrap = document.createElement("ro-tooltip");

      const helpBtn = document.createElement("button");
      helpBtn.type = "button";
      helpBtn.className = "crv2-help";
      helpBtn.setAttribute("aria-label", i18n.help || "Help");
      helpBtn.textContent = "?";
      // helpBtn.setAttribute("slot", "trigger");

      const tooltipContent = document.createElement("div");
      tooltipContent.setAttribute("slot", "content");

      if (rewardType === 1) {
        const rate = toNumber(pb.rate || 0);
        const off =
          rate > 0 ? Math.floor(toNumber(item.rewardPoints) / rate) : 0;
        const line1 = (
          i18n.tooltip_points_off || "{{ amount }} OFF shopping"
        ).replace("{{ amount }}", moneyHtml(off));
        const line2 = (
          i18n.tooltip_points_rate || "{{ rate }} points = $1.00"
        ).replace("{{ rate }}", String(pb.rate || ""));
        tooltipContent.innerHTML = `<div>${line1}</div><div>${line2}</div>`;
      } else {
        const t1 = item?.ruleInfo?.discountTitle
          ? clampText(item.ruleInfo.discountTitle)
          : i18n.promo_codes;
        const t2 =
          item?.ruleInfo?.applicableType === 3 &&
          item?.ruleInfo?.applicableProduct?.[0]?.title
            ? clampText(item.ruleInfo.applicableProduct[0].title)
            : clampText(item?.ruleInfo?.discountTitle2 || "");
        tooltipContent.innerHTML = `<div>${t1}</div>${
          t2 ? `<div>${t2}</div>` : ""
        }`;
      }

      sub.appendChild(subText);
      tooltipWrap.appendChild(helpBtn);
      tooltipWrap.appendChild(tooltipContent);
      sub.appendChild(tooltipWrap);

      top.appendChild(value);
      top.appendChild(sub);
      card.appendChild(top);

      if (stepState === "claimable") {
        const action = document.createElement("div");
        action.className = "crv2-step-action";
        const btn = document.createElement("button");
        btn.type = "button";
        btn.textContent = i18n.receive;
        btn.dataset.uuid = item?.levelReward?.uuid || item?.uuid || "";
        btn.dataset.rewardType = String(item.rewardType || "");
        btn.dataset.rewardPoints = String(item.rewardPoints || 0);
        btn.addEventListener("click", async (e) => {
          e.preventDefault();
          try {
            await withdrawReward(
              btn.dataset.uuid,
              btn.dataset.rewardType,
              btn.dataset.rewardPoints,
            );
          } catch (err) {
            showError();
          }
        });
        action.appendChild(btn);
        card.appendChild(action);
      } else if (stepState === "claimed") {
        const action = document.createElement("div");
        action.className = "crv2-step-action";
        action.textContent = i18n.received;
        card.appendChild(action);
      } else if (stepState === "reached_pending") {
        const action = document.createElement("div");
        action.className = "crv2-step-action crv2-step-action--unavailable";
        action.textContent = i18n.step_not_available_yet || "Not Available Yet";
        card.appendChild(action);
      }

      stepEl.appendChild(card);

      // Only show threshold amount for locked (not yet reached) cards
      if (stepState === "locked") {
        const bottom = document.createElement("div");
        bottom.className = "crv2-step-bottom";
        const threshold = document.createElement("div");
        threshold.className = "crv2-step-threshold";
        threshold.innerHTML = moneyHtml(item.amount);
        bottom.appendChild(threshold);
        stepEl.appendChild(bottom);
      }

      // connector before next item
      els.track.appendChild(stepEl);
      if (idx < levelList.length - 1) {
        const nextItem = levelList[idx + 1];
        const nextStepState = getStepDisplayState(nextItem, progressAmount);

        const connector = document.createElement("div");
        connector.className = "crv2-connector";

        const connectorBg = document.createElement("div");
        connectorBg.className = "crv2-connector-bg";

        const connectorFill = document.createElement("div");
        connectorFill.className = "crv2-connector-fill";

        // Determine fill width: locked = none; next locked = half; else full
        if (stepState === "locked") {
          connectorFill.classList.add("crv2-connector-fill--none");
        } else if (nextStepState === "locked") {
          connectorFill.classList.add("crv2-connector-fill--half");
        } else {
          connectorFill.classList.add("crv2-connector-fill--full");
        }

        connector.appendChild(connectorBg);
        connector.appendChild(connectorFill);
        els.track.appendChild(connector);
      }
    });
    if (els.scrollbox && typeof els.scrollbox.refresh === "function") {
      els.scrollbox.refresh();
    }
  }

  function renderRewardHistory() {
    if (els.inviteBtn)
      els.inviteBtn.classList.remove("crv2-history-invite--pending");

    const listRaw =
      state.rewardList?.list ||
      state.rewardList?.data ||
      state.rewardList?.rows ||
      [];
    const list = Array.isArray(listRaw) ? listRaw : [];

    // decide pagination
    const totalPages =
      Number(
        state.rewardList?.pages ||
          state.rewardList?.totalPages ||
          state.rewardList?.totalPage ||
          0,
      ) || 1;
    const pageNum =
      Number(
        state.rewardList?.pageNum || state.rewardList?.page || state.page || 1,
      ) || 1;

    state.totalPages = totalPages;
    state.page = pageNum;

    // client pagination fallback if backend doesn't paginate but list is long
    state.clientPaginate = false;
    let renderList = list;
    if (totalPages === 1 && list.length > state.clientPageSize) {
      state.clientPaginate = true;
      state.totalPages = Math.ceil(list.length / state.clientPageSize);
      const start = (state.page - 1) * state.clientPageSize;
      renderList = list.slice(start, start + state.clientPageSize);
    }

    const hasData = renderList.length > 0;
    if (els.historyList) setHidden(els.historyList, !hasData);
    if (els.historyEmpty) setHidden(els.historyEmpty, hasData);
    setHidden(els.paginateWrap, !(hasData && state.totalPages > 1));

    if (els.paginate && hasData && state.totalPages > 1) {
      els.paginate.setAttribute("data-current", String(state.page));
      els.paginate.setAttribute("data-total", String(state.totalPages));
    }

    if (!hasData) {
      if (els.tbody) els.tbody.innerHTML = "";
      if (els.cards) els.cards.innerHTML = "";
      return;
    }

    // desktop rows
    if (els.tbody) {
      els.tbody.innerHTML = "";
      renderList.forEach((item) => {
        const row = document.createElement("div");
        row.className = "crv2-tr";
        row.setAttribute("role", "row");

        const productName = Array.isArray(item.productName)
          ? item.productName.join(" ")
          : item.productName;
        const tdProduct = document.createElement("div");
        tdProduct.className = "crv2-td crv2-col-product crv2-td--product";
        tdProduct.textContent = clampText(productName);

        const tdOrder = document.createElement("div");
        tdOrder.className = "crv2-td crv2-col-order";
        tdOrder.textContent = clampText(item.userContact);

        const tdTime = document.createElement("div");
        tdTime.className = "crv2-td crv2-col-time";
        tdTime.textContent = formatOrderTimeDisplay(item, formatTs);

        const tdPrice = document.createElement("div");
        tdPrice.className = "crv2-td crv2-col-price";
        tdPrice.innerHTML = moneyHtml(item.price);

        const tdReward = document.createElement("div");
        tdReward.className = "crv2-col-reward";
        tdReward.textContent = `+${formatInt(item.rewardPoints)}`;

        const tdStatus = document.createElement("div");
        tdStatus.className = "crv2-col-status";

        const status = getRewardStatus(item);
        if (status === "claimable") {
          const btn = document.createElement("button");
          btn.type = "button";
          btn.className = "crv2-status-action crv2-status-action--receive";
          btn.textContent = i18n.receive;
          btn.dataset.uuid = item.uuid || "";
          btn.dataset.rewardPoints = String(item.rewardPoints || 0);
          btn.addEventListener("click", async (e) => {
            e.preventDefault();
            try {
              await withdrawPoints(btn.dataset.uuid, btn.dataset.rewardPoints);
            } catch (err) {
              showError();
            }
          });
          tdStatus.appendChild(btn);
        } else if (status === "claimed") {
          tdStatus.textContent = i18n.received;
          tdStatus.style.color = "var(--second-color)";
        } else {
          const span = document.createElement("span");
          span.className = "crv2-status-action crv2-status-action--disabled";
          span.textContent = i18n.cannot_receive;
          tdStatus.appendChild(span);
        }

        row.appendChild(tdProduct);
        row.appendChild(tdOrder);
        row.appendChild(tdTime);
        row.appendChild(tdPrice);
        row.appendChild(tdReward);
        row.appendChild(tdStatus);

        els.tbody.appendChild(row);
      });
    }

    // mobile/tab cards
    if (els.cards) {
      els.cards.innerHTML = "";
      renderList.forEach((item) => {
        const card = document.createElement("div");
        card.className = "crv2-mcard";

        const top = document.createElement("div");
        top.className = "crv2-mcard-top";

        const order = document.createElement("div");
        order.className = "crv2-mcard-order";
        order.textContent = clampText(item.userContact);

        const reward = document.createElement("div");
        reward.className = "crv2-mcard-reward";
        reward.textContent = `+${formatInt(item.rewardPoints)}`;

        top.appendChild(order);
        top.appendChild(reward);

        const product = document.createElement("div");
        product.className = "crv2-mcard-product";
        const productName = Array.isArray(item.productName)
          ? item.productName.join(" ")
          : item.productName;
        product.textContent = clampText(productName);

        const meta = document.createElement("div");
        meta.className = "crv2-mcard-meta";

        const row1 = document.createElement("div");
        row1.className = "crv2-mrow";
        row1.innerHTML = `<strong>${clampText(
          i18n.mobile_price_label || "Price:",
        )}</strong> ${moneyHtml(item.price)}`;

        const row2 = document.createElement("div");
        row2.className = "crv2-mrow";
        row2.innerHTML = `<strong>${clampText(
          i18n.mobile_order_time_label || "Order Time:",
        )}</strong> ${formatOrderTimeDisplay(item, formatTs)}`;

        meta.appendChild(row1);
        meta.appendChild(row2);

        const divider = document.createElement("div");
        divider.className = "crv2-mdivider";

        const action = document.createElement("div");
        action.className = "crv2-mcard-action";

        const status = getRewardStatus(item);
        if (status === "claimable") {
          const btn = document.createElement("button");
          btn.type = "button";
          btn.className = "crv2-status-action crv2-status-action--receive";
          btn.textContent = i18n.receive;
          btn.dataset.uuid = item.uuid || "";
          btn.dataset.rewardPoints = String(item.rewardPoints || 0);
          btn.addEventListener("click", async (e) => {
            e.preventDefault();
            try {
              await withdrawPoints(btn.dataset.uuid, btn.dataset.rewardPoints);
            } catch (err) {
              showError();
            }
          });
          action.appendChild(btn);
        } else if (status === "claimed") {
          action.textContent = i18n.received;
        } else {
          action.textContent = i18n.received; // design doesn’t show “cannot” on mobile; keep calm default
        }

        card.appendChild(top);
        card.appendChild(product);
        card.appendChild(meta);
        card.appendChild(divider);
        card.appendChild(action);

        els.cards.appendChild(card);
      });
    }
  }

  async function getProgressBar(activityCode) {
    const res = await postJson("/a/ores/re/getProgressBar", { activityCode });
    if (res?.data?.result !== 1) throw new Error("bad result");
    state.progressBar = res.data.data || {};
    renderProgress();
  }

  async function getOrderRewardList(activityCode, page) {
    // Attempt server-side pagination; backend may ignore these fields
    const payload = { activityCode };
    if (page) payload.pageNum = page;
    payload.pageSize = state.clientPageSize;

    const res = await postJson("/a/ores/re/getOrderRewardList", payload);
    if (res?.data?.result !== 1) throw new Error("bad result");
    state.rewardList = res.data.data || {};
    renderRewardHistory();
  }

  async function withdrawReward(uuid, rewardType, rewardPoints) {
    const res = await postJson("/a/ores/re/withdrawReward", { uuid });
    if (res?.data?.result !== 1) throw new Error("bad result");

    if (String(rewardType) === "2") {
      window.RRAmazonAds?.trackSpecialAwards?.({
        hashedEmail: localStorage.getItem("hashEmail") || "",
      });
      openSuccessDialog({
        title:
          root.querySelector("[data-crv2-dialog-title]")?.textContent || "",
        desc: (i18n.success_coupon || "Successfully obtain.").replace(
          "{{ points }}",
          String(rewardPoints || 0),
        ),
      });
    } else {
      const desc = (
        i18n.success_points || "Successfully obtain {{ points }} {{ unit }}"
      )
        .replace("{{ points }}", formatInt(rewardPoints || 0))
        .replace("{{ unit }}", i18n.points_unit || "points");
      openSuccessDialog({
        title:
          root.querySelector("[data-crv2-dialog-title]")?.textContent || "",
        desc,
      });
    }

    await getProgressBar(state.activityCode);
  }

  async function withdrawPoints(uuid, rewardPoints) {
    const res = await postJson("/a/ores/re/withdrawPoints", { uuid });
    if (res?.data?.result !== 1) throw new Error("bad result");
    const desc = (
      i18n.success_points || "Successfully obtain {{ points }} {{ unit }}"
    )
      .replace("{{ points }}", formatInt(rewardPoints || 0))
      .replace("{{ unit }}", i18n.points_unit || "points");
    openSuccessDialog({
      title: root.querySelector("[data-crv2-dialog-title]")?.textContent || "",
      desc,
    });
    await getOrderRewardList(state.activityCode, state.page);
  }

  async function refreshAll() {
    if (state.busy) return;
    state.busy = true;
    try {
      await Promise.all([
        getProgressBar(state.activityCode),
        getOrderRewardList(state.activityCode, state.page),
      ]);
    } catch (e) {
      showError();
    } finally {
      state.busy = false;
    }
  }

  if (els.paginate) {
    els.paginate.addEventListener("change", async (e) => {
      const nextPage = Number(e?.detail?.current || 1) || 1;
      state.page = nextPage;
      if (state.clientPaginate) {
        renderRewardHistory();
        return;
      }
      try {
        await getOrderRewardList(state.activityCode, state.page);
      } catch (err) {
        showError();
      }
    });
  }

  if (els.dialogClose)
    els.dialogClose.addEventListener("click", closeSuccessDialog);

  if (els.lastEventBtn) {
    els.lastEventBtn.addEventListener("click", async () => {
      if (!state.beforeActivityCode) return;
      state.activityCode = state.beforeActivityCode;
      setHidden(els.lastEventBtn, true);
      setHidden(els.currentEventBtn, false);
      state.page = 1;
      await refreshAll();
    });
  }

  if (els.currentEventBtn) {
    els.currentEventBtn.addEventListener("click", async () => {
      state.activityCode = "";
      setHidden(els.currentEventBtn, true);
      setHidden(els.lastEventBtn, !state.beforeActivityCode);
      state.page = 1;
      await refreshAll();
    });
  }

  // Ensure invite links match config if needed
  root.querySelectorAll('a[href="/pages/refer-and-earn"]').forEach((a) => {
    a.setAttribute("href", inviteUrl);
  });

  refreshAll();
});
